import React, { useEffect, useState, useContext } from "react";

import OwlCarousel from 'react-owl-carousel';
import "./css/owl.carousel.min.css";
import "./css/owl.theme.default.min.css";

export const GalleryInt = (props) => {

    const intClassImages = [
        "000001.jpg",
        "000002.jpg",
        "000003.jpg",
        "000004.jpg",
        "000005.jpg",
        "000006.jpg",
        "000007.jpg",
        "000008.jpg",
        "000009.jpg",
    ];

    const intContImages = [
        "000001.jpg",
        "000002.jpg",
        "000003.jpg",
        "000004.jpg",
        "000005.jpg",
        "000006.jpg",
        "000007.jpg",
        "000008.jpg",
        "000009.jpg",
        "000010.jpg",
        "000011.jpg",
        "000012.jpg",
        "000013.jpg",
        "000014.jpg",
        "000015.jpg",
        "000016.jpg",
        "000017.jpg",
        "000018.jpg",
        "000019.jpg",
        "000020.jpg",
        "000021.jpg",
    ];

    return (
        <>
            <div className="container-fluid px-0 bkg-int">
                <div className="row">
                    <div className="col-12">
                        <OwlCarousel className='owl-theme owl-gallery'
                            loop={true}
                            nav={false}
                            dots={true}
                            autoWidth={false}
                            responsive={{
                                    0: {
                                        stagePadding: 25,
                                        items: 1,
                                        dots: false
                                    },
                                    992: {
                                        stagePadding: 250,
                                        items: 2,
                                        dots: true
                                    },
                                    2000: {
                                        stagePadding: 250,
                                        items: 3,
                                        dots: true
                                    }
                                }
                            }
                        >
                            
                            {intClassImages.map((image, i) => <a key={i} href={"images/Infynito80/carousel/int/class/zoom/" + image} data-fancybox="gallery-int" data-caption="">
                                <div className="item">
                                    <img src={"images/Infynito80/carousel/int/class/thumbs/" + image} alt="" className="" />
                                </div>
                            </a>)}


                            {intContImages.map((image, i) => <a key={i}  href={"images/Infynito80/carousel/int/cont/zoom/" + image} data-fancybox="gallery-int" data-caption="">
                                <div className="item">
                                    <img src={"images/Infynito80/carousel/int/cont/thumbs/" + image} alt="" className="" />
                                </div>
                            </a>)}

                           
                        </OwlCarousel>
                    </div>
                </div>
            </div>



        </>
    );




};

export default GalleryInt;